import {usePrimaryClick} from "../../../../hooks/use_primary_click";
import {IPropertyListProperty} from "../../../../property/types/PropertyListProperty";
import {getAmplitudeItemListContextWithStaticFallback} from "../../../../tracking/amplitude/get_amplitude_item_list_context_with_static_fallback";
import {IAmplitudeItemListContext} from "../../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackPropertySelectItemWithListContext} from "../../../../tracking/amplitude/track_property_select_item_with_list_context";
import {gtmEventPropertyListClick} from "../../../../tracking/google_tag_manager/gtm_event_property_list";
import {createOfferListingAmplitudePendingDetailUrl} from "../../../list/helpers/offer_listing_amplitude_item_list_id";
import {hitGTMPropertySelectItem} from "../../../tracking/ecommerce_events/property/hit_gtm_property_select_item";
import {offerBoxTracking} from "../../../tracking/offer_box_gtm_events";
import {IOfferBoxGTMSource} from "../../../types/IOfferBoxGTMSource";
import {IOfferModalOffer} from "../../../types/OfferModalOffer";
import {OfferModalPropertyCard} from "./OfferModalPropertyCard";

interface IProps {
    property: IPropertyListProperty;
    offer: IOfferModalOffer;
    index: number;
    trackingMeta: {
        listName: string;
        listId: string;
        source: IOfferBoxGTMSource;
    };
    amplitudeItemListContext?: IAmplitudeItemListContext | null;
}

export function OfferModalPropertiesListItem(props: IProps) {
    const {property, offer, index, trackingMeta, amplitudeItemListContext} = props;
    const amplitudeSelectItemListContext = getAmplitudeItemListContextWithStaticFallback({
        dynamicItemListContext: amplitudeItemListContext,
        trackingMeta
    });

    const onClick = usePrimaryClick((event: React.MouseEvent<HTMLAnchorElement>) => {
        gtmEventPropertyListClick("rzut");
        trackPropertySelectItemWithListContext({
            offer,
            property,
            index,
            itemListContext: amplitudeSelectItemListContext
        });
        event.currentTarget.href = createOfferListingAmplitudePendingDetailUrl({
            url: event.currentTarget.href,
            itemId: offer.id,
            propertyId: property.id,
            itemListContext: amplitudeItemListContext
        });
        hitGTMPropertySelectItem({
            offer,
            property,
            listName: trackingMeta.listName,
            listId: trackingMeta.listId
        });

        if (trackingMeta.source === "listing") {
            offerBoxTracking.gtm.investTileOfferModal(index);
        } else {
            offerBoxTracking.gtm.investAdditionalOfferModal(index);
        }
    });

    return <OfferModalPropertyCard property={property} offer={offer} onClick={onClick} />;
}
import {usePrimaryClick} from "../../../../hooks/use_primary_click";
import {IPropertyListProperty} from "../../../../property/types/PropertyListProperty";
import {getAmplitudeItemListContextWithStaticFallback} from "../../../../tracking/amplitude/get_amplitude_item_list_context_with_static_fallback";
import {IAmplitudeItemListContext} from "../../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackPropertySelectItemWithListContext} from "../../../../tracking/amplitude/track_property_select_item_with_list_context";
import {gtmEventPropertyListClick} from "../../../../tracking/google_tag_manager/gtm_event_property_list";
import {createOfferListingAmplitudePendingDetailUrl} from "../../../list/helpers/offer_listing_amplitude_item_list_id";
import {hitGTMPropertySelectItem} from "../../../tracking/ecommerce_events/property/hit_gtm_property_select_item";
import {offerBoxTracking} from "../../../tracking/offer_box_gtm_events";
import {IOfferBoxGTMSource} from "../../../types/IOfferBoxGTMSource";
import {IOfferModalOffer} from "../../../types/OfferModalOffer";
import {OfferModalPropertyCard} from "./OfferModalPropertyCard";

interface IProps {
    property: IPropertyListProperty;
    offer: IOfferModalOffer;
    index: number;
    trackingMeta: {
        listName: string;
        listId: string;
        source: IOfferBoxGTMSource;
    };
    amplitudeItemListContext?: IAmplitudeItemListContext | null;
}

export function OfferModalPropertiesListItem(props: IProps) {
    const {property, offer, index, trackingMeta, amplitudeItemListContext} = props;
    const amplitudeSelectItemListContext = getAmplitudeItemListContextWithStaticFallback({
        dynamicItemListContext: amplitudeItemListContext,
        trackingMeta
    });

    const onClick = usePrimaryClick((event: React.MouseEvent<HTMLAnchorElement>) => {
        gtmEventPropertyListClick("rzut");
        trackPropertySelectItemWithListContext({
            offer,
            property,
            index,
            itemListContext: amplitudeSelectItemListContext
        });
        event.currentTarget.href = createOfferListingAmplitudePendingDetailUrl({
            url: event.currentTarget.href,
            itemId: offer.id,
            propertyId: property.id,
            itemListContext: amplitudeItemListContext
        });
        hitGTMPropertySelectItem({
            offer,
            property,
            listName: trackingMeta.listName,
            listId: trackingMeta.listId
        });

        if (trackingMeta.source === "listing") {
            offerBoxTracking.gtm.investTileOfferModal(index);
        } else {
            offerBoxTracking.gtm.investAdditionalOfferModal(index);
        }
    });

    return <OfferModalPropertyCard property={property} offer={offer} onClick={onClick} />;
}
